import { Injectable, inject } from "@angular/core";
import { StorageService } from "../storage.service";

@Injectable({
  providedIn: "root",
})
export class TrackingService {
  private storage = inject(StorageService);

  private currentTrack: TrackInterface;

  constructor() {
    const d = new Date();
    this.currentTrack = {
      waypoints: [],
      start: d.getTime(),
      end: null,
    };
  }

  public addPoint2currentTrack(point: number[]): void {
    this.currentTrack.waypoints.push(point);
  }

  public startNewTrack(): void {
    const d = new Date();
    this.currentTrack = {
      waypoints: [],
      start: d.getTime(),
      end: null,
    };
  }

  public getCurrentTrack(): TrackInterface {
    return this.currentTrack;
  }

  public setCurrentTrack(track: TrackInterface): void {
    this.currentTrack = track;
  }

  private saveTracks(result: TrackInterface[]): Promise<any> {
    return new Promise((resolve, reject) => {
      const d = new Date();
      for (let i = 0; i < result.length; i++) {
        if (result[i].start + 24 * 3600 * 1000 < d.getTime()) {
          result.splice(i, 1);
          i--;
        }
      }
      this.storage
        .set("tracks", result)
        .then(() => {
          resolve({});
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async addTrack(track: TrackInterface): Promise<any> {
    try {
      let res: TrackInterface[] = await this.storage.get("tracks");

      if (!res) {
        res = []; // If no tracks are stored, initialize with an empty array
      }

      res.unshift(track);
      await this.saveTracks(res);
    } catch (err) {
      console.error("Error in addTrack: ", err);
      throw err;
    }
  }

  public async getTracks(): Promise<TrackInterface[]> {
    try {
      let res: TrackInterface[] = await this.storage.get("tracks");
      const d = new Date();

      // Remove expired tracks (older than 24 hours)
      res = res.filter((track) => track.start + 24 * 3600 * 1000 >= d.getTime());

      // Sort the remaining tracks by start time
      res.sort((a, b) => a.start - b.start);

      return res;
    } catch (err) {
      console.error("Error in getTracks: ", err);
      return []; // Return an empty array in case of an error
    }
  }
}

export interface TrackInterface {
  waypoints: number[][]; // lon, lat, altitude
  start: number;
  end: number;
}
